import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Grill = createSvgIcon(
  <path d="M1.5 2.625V7.5H0v2.25h1.5V24h2.25v-3.75h12.017a4.125 4.125 0 1 0 5.983-4.05V9.75H24V7.5h-2.25V2.625A2.625 2.625 0 0 0 19.125 0h-15A2.625 2.625 0 0 0 1.5 2.625Zm2.625-.375h15c.207 0 .375.168.375.375V7.5H3.75V2.625c0-.207.168-.375.375-.375Zm9.375 7.5h6v6.017A4.127 4.127 0 0 0 16.2 18h-2.7V9.75Zm-9.75 0h7.5V18h-7.5V9.75Z" />,
  'Grill'
);

export { Grill };